const PORTAL_JUST_LOGGED_IN_KEY = 'portal-just-logged-in' as const
const FLAG_VALUE = '1' as const

export const portalLoginFlag = {
  set: (): void => {
    if (typeof window === 'undefined') return
    sessionStorage.setItem(PORTAL_JUST_LOGGED_IN_KEY, FLAG_VALUE)
  },
  isSet: (): boolean => {
    if (typeof window === 'undefined') return false
    return sessionStorage.getItem(PORTAL_JUST_LOGGED_IN_KEY) === FLAG_VALUE
  },
  clear: (): void => {
    if (typeof window === 'undefined') return
    sessionStorage.removeItem(PORTAL_JUST_LOGGED_IN_KEY)
  },
}
